import styled, { css } from "styled-components";

export const TriggerButton = styled.button`
  display: flex;
  align-items: center;
  align-self: flex-start;
  width: fit-content;
  flex-shrink: 0;
  gap: 6px;
  padding: 8px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  background-color: ${({ theme }) => theme.colors.secondary.secondary};

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }

  .selectedIcon {
    width: 16px !important;
    height: 16px !important;
    color: ${({ theme }) => theme.colors.surface.onSurfaceVariant} !important;
  }

  .chevronIcon {
    width: 12px !important;
    height: 12px !important;
    color: ${({ theme }) => theme.colors.surface.onSurfaceVariant} !important;
  }
`;

export const PopoverContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 248px;
  height: 284px;
  padding: 8px;
`;

export const SearchBox = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 6px;
  padding: 6px;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.secondary.secondary};

  .searchIcon {
    width: 16px !important;
    height: 16px !important;
    flex-shrink: 0;
    color: ${({ theme }) => theme.colors.surface.onSurfacePlaceholder} !important;
  }

  .searchField {
    flex: 1;
    min-width: 0;
    border: none;
    outline: none;
    background: transparent;
    font-family: 'Open Sans';
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    color: ${({ theme }) => theme.colors.secondary.onSecondary};

    &::placeholder {
      color: ${({ theme }) => theme.colors.surface.onSurfacePlaceholder};
    }
  }
`;

export const GroupsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
`;

export const IconGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;

  .groupTitle {
    font-size: 10px;
    font-weight: 600;
    line-height: 14px;
    color: ${({ theme }) => theme.colors.secondary.onSecondaryVariant};
  }
`;

export const IconsGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
`;

interface IIconOption {
  selected?: boolean;
}

export const IconOption = styled.button<IIconOption>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 2px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  background-color: transparent;

  .icon {
    width: 16px !important;
    height: 16px !important;
    color: ${({ theme }) => theme.colors.surface.onSurfaceVariant} !important;
  }

  &:hover {
    background-color: ${({ theme }) => `color-mix(in srgb, ${theme.colors.primary.primaryHover}, ${theme.colors.surface.surface})`};
  }

  ${({ selected, theme }) => selected && css`
    background-color: color-mix(in srgb, ${theme.colors.primary.primaryPressed}, ${theme.colors.surface.surface});

    .icon {
      color: ${theme.colors.primary.primary} !important;
    }
  `}
`;

export const EmptyResult = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.surface.onSurfaceVariant};
  padding: 8px 0;
`;
